import React from "react";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import HeadlineText from "../../components/TextComponents/HeadlineText";

const ReturnsSlice1 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="col-2 row" style={{ width: 840 }}>
      <div className="col-6">
        <HeadlineText
          styles={{
            marginTop: "5rem",
            textAlign: "left",
            marginLeft: "10vh",
          }}
          text={t("returns")}
          classNames="text-start"
        ></HeadlineText>
        <div
          style={{
            width: "100%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "2rem",
            marginLeft: "10vh",
            marginTop: "4vh",
          }}
        >
          {t("Your evrbed")}
        </div>
        <div
          style={{
            width: "140%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginTop: 8,
            marginLeft: "10vh",
            fontSize: "1.7rem",
          }}
        >
          {t("We support our customers for life.")}
        </div>
        <div
          style={{
            borderRadius: "0px 80px 0px 80px",
            width: 230,
            height: 270,
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: theme.COLORS.GREEN.green,
            marginLeft: "-9vh",
            marginTop: "8vh",
            opacity: 0.25,
          }}
        />
        <div
          style={{
            background: "#ABE1FA",
            borderRadius: "130px 0px 130px 0px",
            marginLeft: "50px",
            marginTop: "-145px",
            width: 420,
            height: 320,
            opacity: 0.35,
            zIndex: 100,
            boxShadow: "4px 4px 0px #005DFF0F",
          }}
        ></div>
      </div>
    </div>
  );
};

export default ReturnsSlice1;
